import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  "aria-controls": "ab_account_profile_details",
  "aria-expanded": "false",
  class: "card-header card-header-jaya cursor-pointer",
  "data-bs-target": "#ab_account_profile_details",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_3 = {
  id: "ab_account_profile_details",
  class: "collapse"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Nom", -1)
const _hoisted_7 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "fv-row mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3 required",
  for: "first_name"
}, "Prénom", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "fv-row mb-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3 required",
  for: "last_name"
}, "Nom", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Mettre à jour ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Statut", -1)
const _hoisted_26 = {
  key: 0,
  class: "fs-6 fw-bold text-gray-600"
}
const _hoisted_27 = {
  key: 1,
  class: "fs-6 fw-bold text-gray-600"
}
const _hoisted_28 = { class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-danger rounded border-danger border border-dashed mb-9 p-6" }
const _hoisted_29 = { class: "svg-icon svg-icon-2tx svg-icon-danger m-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " Vous êtes sur le point de modifier votre statut de compte AgriBEST ! "),
    /*#__PURE__*/_createElementVNode("ul", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("li", null, " Cette information est utilisée pour savoir si vos exploitations et vos diagnostics correspondent à des cas réels ou non. "),
      /*#__PURE__*/_createElementVNode("li", null, " Un agriculteur professionnel doit notamment mentionner le numéro de SIREN de ses exploitations. "),
      /*#__PURE__*/_createElementVNode("li", null, " Un changement ne doit être effectué que si une erreur a été faite à l'inscription. "),
      /*#__PURE__*/_createElementVNode("li", null, " Si vous changez de statut, les nouvelles exploitations et nouveaux diagnostics seront par défault des cas simulés. Les exploitations et diagnostics précédemment renseignés resteront en revanche inchangés. ")
    ])
  ])
], -1)
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "fv-row mb-0 d-flex flex-column" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3 required",
  for: "professional_farmer"
}, "Statut", -1)
const _hoisted_35 = { class: "form-check form-check-custom form-check-solid required" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3" }, " Je suis agriculteur à titre principal ou secondaire ", -1)
const _hoisted_37 = { class: "form-check form-check-custom form-check-solid mt-2 required" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3" }, " Je ne suis pas agriculteur ", -1)
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "d-flex justify-content-end" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Mettre à jour ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "card mb-5 mb-xl-10" }
const _hoisted_47 = {
  "aria-controls": "ab_account_signin_method",
  "aria-expanded": "false",
  class: "card-header card-header-jaya cursor-pointer",
  "data-bs-target": "#ab_account_signin_method",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_48 = {
  id: "ab_account_signin_method",
  class: "collapse"
}
const _hoisted_49 = { class: "card-body border-top p-9" }
const _hoisted_50 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_51 = { id: "kt_signin_email" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Adresse Email", -1)
const _hoisted_53 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_54 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Mot de passe", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Utilisez au moins 10 caractères avec au moins un chiffre, une minuscule, une majuscule et un caractère spécial parmi les suivants : ~ ! @ # $ % ^ & * ( ) _ + { } \" : ; ' [ ] ? , . \\ / = + € - ° § ¿ • ± ¥ Ø ", -1)
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "mb-4" }
const _hoisted_61 = { class: "fv-row mb-0" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3",
  for: "old_password"
}, "Mot de passe actuel", -1)
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "col-lg-6" }
const _hoisted_66 = { class: "fv-row mb-0" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3",
  for: "password"
}, "Nouveau mot de passe", -1)
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "col-lg-6" }
const _hoisted_71 = { class: "fv-row mb-0" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3",
  for: "password_confirm"
}, "Confirmation du nouveau mot de passe", -1)
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "d-flex justify-content-end" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Mettre à jour ", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = { class: "card mb-5 mb-xl-10" }
const _hoisted_81 = {
  "aria-controls": "ab_account_data_policy",
  "aria-expanded": "false",
  class: "card-header card-header-jaya cursor-pointer",
  "data-bs-target": "#ab_account_data_policy",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_82 = {
  id: "ab_account_data_policy",
  class: "collapse"
}
const _hoisted_83 = { class: "card-body border-top p-9" }
const _hoisted_84 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Finalités de traitement", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, " Choisir quelles informations je partage, avec qui et dans quel but. ", -1)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_89 = { class: "svg-icon svg-icon-2tx svg-icon-warning m-4" }
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Vous êtes sur le point de modifier la politique de partage de vos données ! </h4><p class=\"fs-6 text-gray-600\"> Vous pouvez accepter ou refuser que vos données, dont vous êtes l&#39;unique propriétaire, soient utilisées pour chacune des finalités de traitement ci-dessous. </p><p class=\"fs-6 text-gray-600\"> Les choix réalisés ici s&#39;appliquent à l&#39;ensemble de vos données, exploitations et diagnostics. </p></div></div>", 1)
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "text-gray-800 fw-bolder" }
const _hoisted_93 = { class: "form-check form-check-custom form-check-solid form-check-primary" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Tout accepter ", -1)
const _hoisted_95 = { class: "form-check form-check-custom form-check-solid form-check-danger" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Tout refuser ", -1)
const _hoisted_97 = { class: "form-check form-check-custom form-check-solid form-check-success" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Réinitialiser ", -1)
const _hoisted_99 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid form-check-warning"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Choix différencié ", -1)
const _hoisted_101 = ["id"]
const _hoisted_102 = { class: "accordion-item border-top-0 border-right-0 border-left-0" }
const _hoisted_103 = ["id"]
const _hoisted_104 = ["data-bs-target", "aria-controls"]
const _hoisted_105 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_106 = { class: "accordion-body" }
const _hoisted_107 = { class: "fv-row mb-0 d-flex flex-column border border-bottom-1 border-top-0 border-right-0 border-left-0 border-light pb-2" }
const _hoisted_108 = ["for"]
const _hoisted_109 = { class: "fv-row mb-0 d-flex" }
const _hoisted_110 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " J'accepte ", -1)
const _hoisted_112 = { class: "form-check form-check-custom form-check-solid mt-2 form-check-danger" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Je refuse ", -1)
const _hoisted_114 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid mt-2 form-check-warning"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray fs-6 ms-0 me-3" }, " Je conserve ma configuration différenciée actuelle ", -1)
const _hoisted_116 = { class: "fv-plugins-message-container" }
const _hoisted_117 = { class: "fv-help-block" }
const _hoisted_118 = {
  key: 0,
  class: "fv-help-block text-warning"
}
const _hoisted_119 = { class: "d-flex justify-content-end" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Mettre à jour ", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_122 = [
  _hoisted_120,
  _hoisted_121
]
const _hoisted_123 = { class: "card mb-5 mb-xl-10" }
const _hoisted_124 = {
  "aria-controls": "ab_account_rgpd_right",
  "aria-expanded": "false",
  class: "card-header card-header-jaya cursor-pointer",
  "data-bs-target": "#ab_account_rgpd_right",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_125 = {
  id: "ab_account_rgpd_right",
  class: "collapse"
}
const _hoisted_126 = { class: "card-body border-top p-9" }
const _hoisted_127 = { class: "d-flex justify-content-center flex-wrap" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-light-secondary m-2 text-center" }, " Conditions générales d'utilisation ", -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-light-secondary m-2 text-center" }, " Charte de protection des données personnelles ", -1)
const _hoisted_131 = [
  _hoisted_130
]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-light-secondary m-2 text-center" }, " Politique de cookies et traceurs ", -1)
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-light-secondary m-2 text-center" }, " Visiter le site de la CNIL ", -1)
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:contact@agribest.fr" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-lg btn-light-secondary m-2 text-center" }, " Poser vos questions par mail ")
], -1)
const _hoisted_137 = { class: "row g-0 align-items-stretch" }
const _hoisted_138 = { class: "m-3 p-5 border rounded w-100 d-flex flex-column align-items-center" }
const _hoisted_139 = { class: "text-center" }
const _hoisted_140 = ["data-bs-target"]
const _hoisted_141 = { class: "d-flex justify-content-center m-2" }
const _hoisted_142 = { class: "svg-icon svg-icon-4x svg-icon-primary" }
const _hoisted_143 = { class: "text-center" }
const _hoisted_144 = { class: "text-center" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("strong", null, "Et sur Agribest ?", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_147 = ["id"]
const _hoisted_148 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_149 = { class: "modal-content" }
const _hoisted_150 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\">Vous quittez AgriBEST !</h5><div aria-label=\"Close\" class=\"btn btn-icon btn-sm btn-active-light-primary ms-2\" data-bs-dismiss=\"modal\"><span class=\"svg-icon svg-icon-2x\"></span></div></div><div class=\"modal-body\"><p> En cliquant sur OK, vous allez être redirigé vers le site de la CNIL pour obtenir plus d&#39;informations sur vos droits concernant le RGPD. </p></div>", 2)
const _hoisted_152 = { class: "modal-footer" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary",
  type: "button"
}, "Ok", -1)
const _hoisted_155 = [
  _hoisted_154
]
const _hoisted_156 = { class: "card mb-5 mb-xl-10" }
const _hoisted_157 = {
  "aria-controls": "ab_account_deactivate",
  "aria-expanded": "true",
  class: "card-header card-header-jaya cursor-pointer border-danger",
  "data-bs-target": "#ab_account_deactivate",
  "data-bs-toggle": "collapse",
  role: "button"
}
const _hoisted_158 = {
  id: "ab_account_deactivate",
  class: "collapse"
}
const _hoisted_159 = { class: "card-body border-top p-9" }
const _hoisted_160 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Date de création du compte", -1)
const _hoisted_162 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_163 = { class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-danger rounded border-danger border border-dashed mb-9 p-6" }
const _hoisted_164 = { class: "svg-icon svg-icon-2tx svg-icon-danger m-4" }
const _hoisted_165 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Vous êtes sur le point de supprimer votre compte AgriBEST ! </h4><ul class=\"fs-6 text-gray-600\"><li> Vous perdrez l&#39;accès en ligne à l&#39;ensemble des informations de votre compte, de vos exploitations et de vos diagnostics. Vous pouvez néanmoins télécharger toutes vos données pour les conserver. </li><li> Vous ne pourrez plus accéder au site et à l&#39;application AgriBEST, et donc créer des exploitations, remplir des diagnostics et visualiser les résultats. Créer un nouveau compte sera nécessaire. </li></ul><div class=\"fs-6 text-gray-600\"> Par sécurité, la suppression nécessite le renseignement et confirmation de votre mot de passe : </div></div></div>", 1)
const _hoisted_166 = { class: "row mb-6" }
const _hoisted_167 = { class: "col-lg-6" }
const _hoisted_168 = { class: "fv-row mb-0" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3",
  for: "password_delete"
}, "Mot de passe", -1)
const _hoisted_170 = { class: "fv-plugins-message-container" }
const _hoisted_171 = { class: "fv-help-block" }
const _hoisted_172 = { class: "col-lg-6" }
const _hoisted_173 = { class: "fv-row mb-0" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fs-6 fw-bolder mb-3",
  for: "password_confirm_delete"
}, "Confirmation du mot de passe", -1)
const _hoisted_175 = { class: "fv-plugins-message-container" }
const _hoisted_176 = { class: "fv-help-block" }
const _hoisted_177 = { class: "d-flex justify-content-end" }
const _hoisted_178 = ["disabled"]
const _hoisted_179 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Supprimer le compte ", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_181 = [
  _hoisted_179,
  _hoisted_180
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_card_title_jaya, {
          "duotune-icon": "communication/com013",
          title: "Mon profil",
          "sub-title": "Nom et statut"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              id: "ab_name",
              class: _normalizeClass({ 'd-none': _ctx.updateNameFormDisplay })
            }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.profileDetails.first_name + " " + _ctx.profileDetails.last_name), 1)
            ], 2),
            _createElementVNode("div", {
              id: "ab_name_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.updateNameFormDisplay }, "flex-row-fluid"])
            }, [
              _createVNode(_component_Form, {
                id: "ab_name_update",
                "validation-schema": _ctx.updateNameValidator,
                class: "form fv-plugins-bootstrap5 fv-plugins-framework",
                onSubmit: _ctx.updateName
              }, {
                default: _withCtx(({ meta }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_Field, {
                          id: "first_name",
                          placeholder: _ctx.profileDetails.first_name,
                          value: _ctx.profileDetails.first_name,
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "first_name",
                          type: "text"
                        }, null, 8, ["placeholder", "value"]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_ErrorMessage, { name: "first_name" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_Field, {
                          id: "last_name",
                          placeholder: _ctx.profileDetails.last_name,
                          value: _ctx.profileDetails.last_name,
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "last_name",
                          type: "text"
                        }, null, 8, ["placeholder", "value"]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ErrorMessage, { name: "last_name" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      id: "ab_name_cancel",
                      class: "btn btn-light-warning px-6",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateNameFormDisplay = !_ctx.updateNameFormDisplay))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      id: "ab_name_submit",
                      ref: "updateNameButton",
                      class: _normalizeClass(["btn btn-primary ms-2 px-6", !_ctx.isOnline ? 'disabled' : '']),
                      disabled: !(meta.valid && meta.dirty),
                      type: "submit"
                    }, _hoisted_23, 10, _hoisted_20)
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ], 2),
            _createElementVNode("div", {
              id: "ab_name_button",
              class: _normalizeClass([{ 'd-none': _ctx.updateNameFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light fw-boldest", !_ctx.isOnline ? 'disabled' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateNameFormDisplay = !_ctx.updateNameFormDisplay))
              }, " Mettre à jour ", 2)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              id: "ab_statut",
              class: _normalizeClass({ 'd-none': _ctx.updateStatutFormDisplay })
            }, [
              _hoisted_25,
              (_ctx.profileDetails.professional_farmer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Je suis agriculteur à titre principal ou secondaire "))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, " Je ne suis pas agriculteur "))
            ], 2),
            _createElementVNode("div", {
              id: "ab_statut_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.updateStatutFormDisplay }, "flex-row-fluid"])
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_30
              ]),
              _createVNode(_component_Form, {
                id: "ab_statut_update",
                "validation-schema": _ctx.updateStatutValidator,
                class: "form fv-plugins-bootstrap5 fv-plugins-framework",
                onSubmit: _ctx.updateStatut
              }, {
                default: _withCtx(({ meta }) => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("label", _hoisted_35, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.profileDetails.professional_farmer,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.professional_farmer) = $event)),
                            class: "form-check-input me-3",
                            name: "professional_farmer",
                            type: "radio",
                            value: true
                          }, null, 8, ["modelValue"]),
                          _hoisted_36
                        ]),
                        _createElementVNode("label", _hoisted_37, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.profileDetails.professional_farmer,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.professional_farmer) = $event)),
                            class: "form-check-input me-3",
                            name: "professional_farmer",
                            type: "radio",
                            value: false
                          }, null, 8, ["modelValue"]),
                          _hoisted_38
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_ErrorMessage, { name: "professional_farmer" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      id: "ab_statut_cancel",
                      class: "btn btn-light-warning px-6",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateStatutFormDisplay = !_ctx.updateStatutFormDisplay))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      id: "ab_statut_submit",
                      ref: "updateStatutButton",
                      class: _normalizeClass(["btn btn-primary ms-2 px-6", !_ctx.isOnline ? 'disabled' : '']),
                      disabled: !(meta.valid && meta.dirty),
                      type: "submit"
                    }, _hoisted_45, 10, _hoisted_42)
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ], 2),
            _createElementVNode("div", {
              id: "ab_statut_button",
              class: _normalizeClass([{ 'd-none': _ctx.updateStatutFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light fw-boldest", !_ctx.isOnline ? 'disabled' : '']),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateStatutFormDisplay = !_ctx.updateStatutFormDisplay))
              }, " Mettre à jour ", 2)
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_card_title_jaya, {
          "duotune-icon": "technology/teh004",
          title: "Mes identifiants",
          "sub-title": "Mail et mot de passe"
        })
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.profileDetails.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.updatePasswordFormDisplay })
            }, _hoisted_57, 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.updatePasswordFormDisplay }, "flex-row-fluid"])
            }, [
              _hoisted_58,
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                "validation-schema": _ctx.updatePasswordValidator,
                class: "form fv-plugins-bootstrap5 fv-plugins-framework",
                onSubmit: _ctx.updatePassword
              }, {
                default: _withCtx(({ meta }) => [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _createVNode(_component_Field, {
                          id: "old_password",
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "old_password",
                          type: _ctx.toggleVisibility ? 'password' : 'text'
                        }, null, 8, ["type"]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_ErrorMessage, { name: "old_password" })
                          ])
                        ]),
                        _createElementVNode("div", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleVisibility = !_ctx.toggleVisibility)),
                          class: "mt-3 text-end link-primary fs-6 fw-bold"
                        }, _toDisplayString(_ctx.toggleVisibility
                          ? "Voir le mot de passe"
                          : "Cacher le mot de passe"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _createVNode(_component_Field, {
                          id: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "password",
                          type: _ctx.toggleVisibility ? 'password' : 'text'
                        }, null, 8, ["type"]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createVNode(_component_Field, {
                          id: "password_confirm",
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "password_confirm",
                          type: _ctx.toggleVisibility ? 'password' : 'text'
                        }, null, 8, ["type"]),
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createVNode(_component_ErrorMessage, { name: "password_confirm" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      class: "btn btn-light-warning px-6",
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.updatePasswordFormDisplay = !_ctx.updatePasswordFormDisplay
                  ))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      id: "kt_password_submit",
                      ref: "updatePasswordButton",
                      class: _normalizeClass(["btn btn-primary ms-2 px-6", !_ctx.isOnline ? 'disabled' : '']),
                      disabled: !(meta.valid && meta.dirty),
                      type: "submit"
                    }, _hoisted_79, 10, _hoisted_76)
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass([{ 'd-none': _ctx.updatePasswordFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light fw-boldest", !_ctx.isOnline ? 'disabled' : '']),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updatePasswordFormDisplay = !_ctx.updatePasswordFormDisplay))
              }, " Mettre à jour ", 2)
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createVNode(_component_card_title_jaya, {
          "duotune-icon": "files/fil012",
          title: "Mes données",
          "sub-title": "Gestion du partage de mes données"
        })
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", {
              id: "ab_account_data_policy",
              class: _normalizeClass({ 'd-none': _ctx.updateDataPolicyFormDisplay })
            }, _hoisted_87, 2),
            _createElementVNode("div", {
              id: "ab_account_data_policy_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.updateDataPolicyFormDisplay }, "flex-row-fluid"])
            }, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("span", _hoisted_89, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_90
              ]),
              _createVNode(_component_Form, {
                id: "ab_account_data_policy_update",
                class: "form fv-plugins-bootstrap5 fv-plugins-framework",
                onSubmit: _ctx.updateDataPolicy
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_91, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gdprRecipientTypes, (gdprRecipientType, idRecipient) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: gdprRecipientType.choice,
                        class: "mb-5"
                      }, [
                        _createElementVNode("h4", _hoisted_92, " Partage avec les " + _toDisplayString(gdprRecipientType.name) + " : ", 1),
                        _createElementVNode("p", null, _toDisplayString(gdprRecipientType.description) + ".", 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["fv-row mb-3 d-flex flex-wrap", 
                      _ctx.getNewPurposesStateGlobal(gdprRecipientType).length === 1
                        ? 'd-none'
                        : ''
                    ])
                        }, [
                          _createElementVNode("label", _hoisted_93, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.newRecipientPurposesStateGlobal[idRecipient],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.newRecipientPurposesStateGlobal[idRecipient]) = $event),
                              class: "form-check-input me-3",
                              name: 
                          'newRecipientPurposesStateGlobal' +
                          idRecipient.toString()
                        ,
                              type: "radio",
                              value: 2,
                              onChange: ($event: any) => (
                          _ctx.setNewGdprPurposeStateGlobal(
                            gdprRecipientType.choice,
                            idRecipient
                          )
                        )
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                            _hoisted_94
                          ]),
                          _createElementVNode("label", _hoisted_95, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.newRecipientPurposesStateGlobal[idRecipient],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.newRecipientPurposesStateGlobal[idRecipient]) = $event),
                              class: "form-check-input me-3",
                              name: 
                          'newRecipientPurposesStateGlobal' +
                          idRecipient.toString()
                        ,
                              type: "radio",
                              value: 3,
                              onChange: ($event: any) => (
                          _ctx.setNewGdprPurposeStateGlobal(
                            gdprRecipientType.choice,
                            idRecipient
                          )
                        )
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                            _hoisted_96
                          ]),
                          _createElementVNode("label", _hoisted_97, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.newRecipientPurposesStateGlobal[idRecipient],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.newRecipientPurposesStateGlobal[idRecipient]) = $event),
                              class: "form-check-input me-3",
                              name: 
                          'newRecipientPurposesStateGlobal' +
                          idRecipient.toString()
                        ,
                              type: "radio",
                              value: 5,
                              onChange: ($event: any) => (
                          _ctx.setNewGdprPurposeStateGlobal(
                            gdprRecipientType.choice,
                            idRecipient
                          )
                        )
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                            _hoisted_98
                          ]),
                          (_ctx.newRecipientPurposesStateGlobal[idRecipient] === 4)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_99, [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.newRecipientPurposesStateGlobal[idRecipient],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.newRecipientPurposesStateGlobal[idRecipient]) = $event),
                                  class: "form-check-input me-3",
                                  name: 
                          'newRecipientPurposesStateGlobal' +
                          idRecipient.toString()
                        ,
                                  type: "radio",
                                  value: 4,
                                  disabled: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                                _hoisted_100
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: "accordion",
                          id: 'kt_accordion_1' + idRecipient.toString()
                        }, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("h5", {
                              class: "accordion-header",
                              id: 'kt_accordion_1_header_1' + idRecipient.toString()
                            }, [
                              _createElementVNode("button", {
                                class: "accordion-button text-gray-600 fst-normal fw-normal collapsed",
                                type: "button",
                                "data-bs-toggle": "collapse",
                                "data-bs-target": 
                            '#kt_accordion_1_body_1' + idRecipient.toString()
                          ,
                                "aria-expanded": "false",
                                "aria-controls": 
                            'kt_accordion_1_body_1' + idRecipient.toString()
                          
                              }, " Voir le détail de toutes les finalités de traitement de vos données pour les " + _toDisplayString(gdprRecipientType.name), 9, _hoisted_104)
                            ], 8, _hoisted_103),
                            _createElementVNode("div", {
                              id: 'kt_accordion_1_body_1' + idRecipient.toString(),
                              class: _normalizeClass(["accordion-collapse collapse", 
                          _ctx.getNewPurposesStateGlobal(gdprRecipientType)
                            .length === 1
                            ? 'show'
                            : ''
                        ]),
                              "aria-labelledby": 
                          'kt_accordion_1_header_1' + idRecipient.toString()
                        ,
                              "data-bs-parent": 
                          '#kt_accordion_1' + idRecipient.toString()
                        
                            }, [
                              _createElementVNode("div", _hoisted_106, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNewPurposesStateGlobal(
                              gdprRecipientType
                            ), (purposeStateGlobal) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mb-6",
                                    key: purposeStateGlobal.id
                                  }, [
                                    _createElementVNode("div", _hoisted_107, [
                                      _createElementVNode("label", {
                                        class: "form-label fs-6 fw-lighter fst-italic mb-3 required",
                                        for: 
                                  'newPurposesStateGlobal' +
                                  purposeStateGlobal.id.toString() +
                                  idRecipient.toString()
                                
                                      }, _toDisplayString(purposeStateGlobal.purpose.description), 9, _hoisted_108),
                                      _createElementVNode("div", _hoisted_109, [
                                        _createElementVNode("label", _hoisted_110, [
                                          _createVNode(_component_Field, {
                                            modelValue: purposeStateGlobal.state,
                                            "onUpdate:modelValue": ($event: any) => ((purposeStateGlobal.state) = $event),
                                            class: "form-check-input me-3",
                                            name: 
                                      'newPurposesStateGlobal' +
                                      purposeStateGlobal.id.toString() +
                                      idRecipient.toString()
                                    ,
                                            type: "radio",
                                            value: 2,
                                            onChange: ($event: any) => (
                                      _ctx.setNewRecipientGdprPurposeStateGlobal(
                                        gdprRecipientType.choice,
                                        idRecipient
                                      )
                                    )
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                                          _hoisted_111
                                        ]),
                                        _createElementVNode("label", _hoisted_112, [
                                          _createVNode(_component_Field, {
                                            modelValue: purposeStateGlobal.state,
                                            "onUpdate:modelValue": ($event: any) => ((purposeStateGlobal.state) = $event),
                                            class: "form-check-input me-3",
                                            name: 
                                      'newPurposesStateGlobal' +
                                      purposeStateGlobal.id.toString() +
                                      idRecipient.toString()
                                    ,
                                            type: "radio",
                                            value: 3,
                                            onChange: ($event: any) => (
                                      _ctx.setNewRecipientGdprPurposeStateGlobal(
                                        gdprRecipientType.choice,
                                        idRecipient
                                      )
                                    )
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                                          _hoisted_113
                                        ]),
                                        (purposeStateGlobal.state === 4)
                                          ? (_openBlock(), _createElementBlock("label", _hoisted_114, [
                                              _createVNode(_component_Field, {
                                                modelValue: purposeStateGlobal.state,
                                                "onUpdate:modelValue": ($event: any) => ((purposeStateGlobal.state) = $event),
                                                class: "form-check-input me-3",
                                                name: 
                                      'newPurposesStateGlobal' +
                                      purposeStateGlobal.id.toString() +
                                      idRecipient.toString()
                                    ,
                                                type: "radio",
                                                value: 4,
                                                onChange: ($event: any) => (
                                      _ctx.setNewRecipientGdprPurposeStateGlobal(
                                        gdprRecipientType.choice,
                                        idRecipient
                                      )
                                    )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"]),
                                              _hoisted_115
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_116, [
                                        _createElementVNode("div", _hoisted_117, [
                                          _createVNode(_component_ErrorMessage, {
                                            name: 
                                      'newPurposesStateGlobal' +
                                      purposeStateGlobal.id.toString() +
                                      idRecipient.toString()
                                    
                                          }, null, 8, ["name"])
                                        ]),
                                        (purposeStateGlobal.state === 4)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, " Attention, vous nous avez fait une demande de gestion différenciée. Vous avez accepté l'utilisation de vos données pour cette finalité seulement pour certains contenus spécifiques. Sélectionner \"J'accepte\" ou \"Je refuse\" affectera tous les contenus, vous perdrez donc la capacité de différenciation que vous nous avez demandée. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ], 10, _hoisted_105)
                          ])
                        ], 8, _hoisted_101)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("button", {
                      id: "ab_account_data_policy_cancel",
                      class: "btn btn-light-warning px-6",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (
                    _ctx.updateDataPolicyFormDisplay = !_ctx.updateDataPolicyFormDisplay
                  ))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      id: "ab_account_data_policy_submit",
                      ref: "updateDataPolicyButton",
                      class: _normalizeClass(["btn btn-primary ms-2 px-6", !_ctx.isOnline ? 'disabled' : '']),
                      type: "submit"
                    }, _hoisted_122, 2)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ], 2),
            _createElementVNode("div", {
              id: "ab_account_data_policy_button",
              class: _normalizeClass([{ 'd-none': _ctx.updateDataPolicyFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: "btn btn-light fw-boldest",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (
                _ctx.updateDataPolicyFormDisplay = !_ctx.updateDataPolicyFormDisplay
              ))
              }, " Gérer ")
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_123, [
      _createElementVNode("div", _hoisted_124, [
        _createVNode(_component_card_title_jaya, {
          "duotune-icon": "technology/teh002",
          title: "Mes droits RGPD",
          "sub-title": "Liens utiles"
        })
      ]),
      _createElementVNode("div", _hoisted_125, [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("a", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'general-conditions' })))
            }, _hoisted_129),
            _createElementVNode("a", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push({ name: 'gdpr-charter' })))
            }, _hoisted_131),
            _createElementVNode("a", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push({ name: 'cookie-policy' })))
            }, _hoisted_133),
            _createElementVNode("a", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (
              _ctx.openLinkAgriBest(
                'https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-donnees-personnelles'
              )
            ))
            }, _hoisted_135),
            _hoisted_136
          ]),
          _createElementVNode("div", _hoisted_137, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightsRGPD, (right, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "d-flex col-xl-6 align-items-stretch"
              }, [
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("h3", _hoisted_139, [
                    _createTextVNode(_toDisplayString(right.title) + " ", 1),
                    _createElementVNode("span", {
                      "data-bs-target": '#redirectCNIL' + i,
                      class: "svg-icon cursor-pointer svg-icon-2x",
                      "data-bs-toggle": "modal"
                    }, [
                      _createVNode(_component_inline_svg, { src: 'media/icons/duotune/general/gen046.svg' }, null, 8, ["src"])
                    ], 8, _hoisted_140)
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("span", _hoisted_142, [
                      _createVNode(_component_inline_svg, {
                        src: 'media/icons/duotune/' + right.duotuneIcon + '.svg'
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_143, _toDisplayString(right.description), 1),
                  _createElementVNode("p", _hoisted_144, [
                    _hoisted_145,
                    _hoisted_146,
                    _createTextVNode(_toDisplayString(right.agribest), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  id: 'redirectCNIL' + i,
                  class: "modal fade",
                  tabindex: "-1"
                }, [
                  _createElementVNode("div", _hoisted_148, [
                    _createElementVNode("div", _hoisted_149, [
                      _hoisted_150,
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.openLinkAgriBest(right.url))
                        }, _hoisted_155, 8, _hoisted_153)
                      ])
                    ])
                  ])
                ], 8, _hoisted_147)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_156, [
      _createElementVNode("div", _hoisted_157, [
        _createVNode(_component_card_title_jaya, {
          "duotune-icon": "general/gen027",
          title: "Supprimer mon compte"
        })
      ]),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", _hoisted_159, [
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", {
              id: "ab_delete_account",
              class: _normalizeClass({ 'd-none': _ctx.deleteAccountFormDisplay })
            }, [
              _hoisted_161,
              _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.profileDetails.date_joined
                  ? _ctx.parseDate(_ctx.profileDetails.date_joined)
                  : "Inconnue"), 1)
            ], 2),
            _createElementVNode("div", {
              id: "ab_delete_account_confirm",
              class: _normalizeClass([{ 'd-none': !_ctx.deleteAccountFormDisplay }, "flex-row-fluid"])
            }, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("span", _hoisted_164, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_165
              ]),
              _createVNode(_component_Form, {
                id: "ab_signin_change_password",
                "validation-schema": _ctx.deleteAccountValidator,
                class: "form fv-plugins-bootstrap5 fv-plugins-framework",
                onSubmit: _ctx.deleteAccount
              }, {
                default: _withCtx(({ meta }) => [
                  _createElementVNode("div", _hoisted_166, [
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _hoisted_169,
                        _createVNode(_component_Field, {
                          id: "password_delete",
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "password",
                          type: _ctx.toggleVisibility ? 'password' : 'text'
                        }, null, 8, ["type"]),
                        _createElementVNode("div", _hoisted_170, [
                          _createElementVNode("div", _hoisted_171, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ]),
                        _createElementVNode("div", {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleVisibility = !_ctx.toggleVisibility)),
                          class: "mt-3 text-end link-primary fs-6 fw-bold"
                        }, _toDisplayString(_ctx.toggleVisibility
                          ? "Voir le mot de passe"
                          : "Cacher le mot de passe"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _hoisted_174,
                        _createVNode(_component_Field, {
                          id: "password_confirm_delete",
                          class: "form-control form-control-lg form-control-solid fw-bold",
                          name: "password_confirm",
                          type: _ctx.toggleVisibility ? 'password' : 'text'
                        }, null, 8, ["type"]),
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _createVNode(_component_ErrorMessage, { name: "password_confirm" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("button", {
                      id: "ab_deleteaccount_cancel",
                      class: "btn btn-light-warning px-6",
                      type: "button",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteAccountFormDisplay = !_ctx.deleteAccountFormDisplay))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      id: "ab_delete_account_submit",
                      ref: "deleteAccountButton",
                      class: _normalizeClass(["btn btn-danger ms-2 px-6", !_ctx.isOnline ? 'disabled' : '']),
                      disabled: !(meta.valid && meta.dirty),
                      type: "submit"
                    }, _hoisted_181, 10, _hoisted_178)
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ], 2),
            _createElementVNode("div", {
              id: "ab_delete_account_button",
              class: _normalizeClass([{ 'd-none': _ctx.deleteAccountFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light-danger fw-boldest", !_ctx.isOnline ? 'disabled' : '']),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteAccountFormDisplay = !_ctx.deleteAccountFormDisplay))
              }, " Supprimer le compte ", 2)
            ], 2)
          ])
        ])
      ])
    ])
  ], 64))
}